import ButtonWrap from '../../../components/template/ButtonWrap'
import api from '../../../components/utils/api'

const LoadSenseMergeRule = ({ setMergeRuleName, setExistMergeRulePairs }) => {
    const fetchSenseMergeRules = async () => {
        try {
            const res = await api.get(`/api/codi/service-merge-rule`)
            setExistMergeRulePairs(res.data)
            setMergeRuleName("sense_")
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <div className='mr-2'>
            <ButtonWrap contents="Load Sense Merge Rule" onClick={fetchSenseMergeRules} />
        </div>
    )
}

export default LoadSenseMergeRule